export default "/build/images/logo.png?ea49bcd2fe3a719d75ac78667a5ce9ac";